import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { URLs } from "./addin-page-enums";

@Injectable({
  providedIn: "root",
})
export class AddinPageService {
  apiUrl: string = window.apiUrl;

  constructor(private http: HttpClient) {}

  getTickerList(keyWord: string) {
    return this.http.get(`${this.apiUrl}${URLs.getSearchTickers}`, {
      params: {
        q: keyWord,
      },
    });
  }

  getOtherDimMeta(ticker: string, tickertype) {
    const params: any = {
      pg: "IS",
      cut: "NMV",
      ticker,
    };
    if (tickertype) {
      params.tickertype = tickertype;
    }
    return this.http.get(`${this.apiUrl}${URLs.getOtherDimMeta}`, {
      params,
    });
  }

  getSourceMeta(ticker: string, tickertype) {
    const params: any = {
      pg: "IS",
      cut: "NMV",
      ticker,
    };
    if (tickertype) {
      params.tickertype = tickertype;
    }
    return this.http.get(`${this.apiUrl}${URLs.getSourceMeta}`, {
      params,
    });
  }

  saveCustomConsensus(data, tickertype) {
    const params: any = {};
    if (tickertype) {
      params.tickertype = tickertype;
    }
    return this.http.post(`${this.apiUrl}${URLs.gridPanelsHistory}`, data, {
      params,
    });
  }
}
